
document.addEventListener("DOMContentLoaded", () => {

  document.addEventListener('click', async function (e) {

    const button = e.target.closest('.main-product-atc');
    if (!button) return;

    e.preventDefault();
        console.log('button click>>',button);
    const selectedPlan = document.querySelector('input[name="bundle_plan"]:checked');
    if (!selectedPlan) return;

    const selling_plan = selectedPlan.value;
    const bundle_title = selectedPlan.dataset.title;

    let variant_id;
    const onetime = document.querySelector('.onetime:checked');

    let qty = 1;
    let subQty = 1;
    let freeQty = 0;

    if (bundle_title === 'buy-1') {
      qty = 1;
      subQty = 1;
      variant_id = document.querySelector('.variant_id .buy-1')?.value;

    } else if (bundle_title === 'buy-2-get-1-free') {
      qty = 3;
      subQty = 2;
      freeQty = 1;
      variant_id = document.querySelector('.variant_id .buy-2-get-1')?.value;

    } else if (bundle_title === 'buy-3-get-2-free') {
      qty = 5;
      subQty = 3;
      freeQty = 2;
      variant_id = document.querySelector('.variant_id .buy-3-get-2')?.value;
    }

    if (!variant_id) {
      console.error('Variant ID missing');
      return;
    }

    const gift1Id = document.querySelector('.gift1_id')?.value;
    const gift2Id = document.querySelector('.gift2_id')?.value;

    const bundleId = 'bundle_' + Date.now();

    let items = [];

    // ==========================
    // MAIN PRODUCT LOGIC
    // ==========================
    if (onetime) {
      console.log(gift1Id,'gift1Id>>>>');
      items.push({
        id: variant_id,
        quantity: subQty,
        selling_plan: selling_plan,
        properties: { _bundle: bundleId }
      });

      if (freeQty > 0) {
        items.push({
          id: variant_id,
          quantity: freeQty,
          properties: { _bundle: bundleId }
        });
      }

    } else {
        console.log(gift1Id,variant_id,'gift1Id>>>>variant_id');
      items.push({
        id: variant_id,
        quantity: qty,
        properties: { _bundle: bundleId }
      });
    }

    // ==========================
    // GIFT LOGIC
    // ==========================
    if (bundle_title === 'buy-2-get-1-free' && gift1Id) {
      items.push({
        id: gift1Id,
        quantity: 1,
        properties: {
          _free_gift: true,
          _bundle: bundleId
        }
      });
    }

    if (bundle_title === 'buy-3-get-2-free') {
      if (gift1Id) {
        items.push({
          id: gift1Id,
          quantity: 1,
          properties: {
            _free_gift: true,
            _bundle: bundleId
          }
        });
      }

      if (gift2Id) {
        items.push({
          id: gift2Id,
          quantity: 1,
          properties: {
            _free_gift: true,
            _bundle: bundleId
          }
        });
      }
    }

    console.log("Adding items:", items);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items,
          sections: ['cart-drawer', 'cart-icon-bubble']
        })
      });

      const data = await response.json();

      console.log("Cart response:", data);

      // ==========================
      // UPDATE CART DRAWER
      // ==========================
      if (data.sections) {

        window.refreshCart();
      }

      // Open drawer button trigger if available
      const cartDrawerTrigger = document.querySelector('[href="/cart"]');
      if (cartDrawerTrigger) {
        setTimeout(function(){
            cartDrawerTrigger.click();
        },100)
        
      }

    } catch (error) {
      console.error('Cart add failed:', error);
    }

  });

});


// ==========================
// ONETIME / SUB PRICE TOGGLE
// ==========================
document.addEventListener('change', function (e) {

  if (!e.target.classList.contains('onetime')) return;

  const isChecked = e.target.checked;

  document.querySelectorAll('.onetime_price').forEach(el => {
    el.style.display = isChecked ? 'none' : 'block';
  });

  document.querySelectorAll('.rc_price').forEach(el => {
    el.style.display = isChecked ? 'block' : 'none';
  });

});




  // document.addEventListener('click', function (e) {

  //   // Detect remove button (Shopify cart drawer)
  //   const removeBtn = e.target.closest('cart-remove-button');
  //   if (!removeBtn) return;

  //   console.log('🗑 Remove clicked');

  //   // Disable checkout temporarily
  //   const checkoutBtn = document.querySelector('[name="checkout"]');
  //   if (checkoutBtn) {
  //     checkoutBtn.style.pointerEvents = 'none';
  //     checkoutBtn.style.opacity = '0.5';
  //   }

  //   // Wait for Shopify to update cart
  //   setTimeout(async () => {
  //     try {
  //       const cart = await fetch('/cart.js').then(res => res.json());

  //       console.log('Updated cart:', cart);

  //       let updates = {};

  //       cart.items.forEach(item => {

  //         const isGift = item.properties && item.properties._free_gift == true;
  //         const bundleId = item.properties && item.properties._bundle;

  //         console.log({
  //           title: item.title,
  //           isGift,
  //           bundleId
  //         });

  //         // Remove all gift items (based on your requirement)
  //         if (isGift) {
  //           console.log('Removing gift:', item.key);
  //           updates[item.key] = 0;
  //         }

  //       });

  //       console.log('Updates:', updates);

  //       // Apply removal
  //       if (Object.keys(updates).length > 0) {
  //         await fetch('/cart/update.js', {
  //           method: 'POST',
  //           headers: { 'Content-Type': 'application/json' },
  //           body: JSON.stringify({ updates })
  //         });

  //         console.log('Gifts removed');
  //       }

  //       // Refresh cart drawer UI
  //      window.refreshCart();
  //     } catch (err) {
  //       console.error(' Error:', err);
  //     } finally {
        
  //     }

  //   }, 700); // important delay

  // });

document.addEventListener('click', function (e) {

  // ✅ Detect BOTH remove & minus
  const removeBtn = e.target.closest('cart-remove-button');
  const minusBtn = e.target.closest('.quantity__button--minus');

  if (!removeBtn && !minusBtn) return;

  console.log('Triggered:', removeBtn ? 'REMOVE' : 'MINUS');

  const checkoutBtn = document.querySelector('[name="checkout"]');
  if (checkoutBtn) {
    checkoutBtn.style.pointerEvents = 'none';
    checkoutBtn.style.opacity = '0.5';
  }

  setTimeout(async () => {
    try {
      const cart = await fetch('/cart.js').then(res => res.json());

      console.log(' Updated cart:', cart);

      let updates = {};

      cart.items.forEach(item => {

        const isGift = item.properties && item.properties._free_gift == true;

        console.log({
          title: item.title,
          isGift,
          bundle: item.properties?._bundle
        });

        // ✅ YOUR REQUIREMENT:
        // ANY minus OR remove → remove gift immediately
        if (isGift) {
          console.log('Removing gift:', item.key);
          updates[item.key] = 0;
        }

      });

      console.log('Updates:', updates);

      if (Object.keys(updates).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });

        console.log('✅ Gifts removed');
      }

      // refresh drawer
      if (typeof window.refreshCart === 'function') {
        window.refreshCart();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
      if (window.location.pathname === '/cart') {
        window.location.reload();
      }

    } catch (err) {
      console.error('❌ Error:', err);
    } finally {
      setTimeout(() => {
        if (checkoutBtn) {
          checkoutBtn.style.pointerEvents = 'auto';
          checkoutBtn.style.opacity = '1';
        }
      }, 400);
    }

  }, 600); // timing is important

});


window.refreshCart = () => {
  fetch(`${routes.cart_url}?section=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      // console.log("html:", html);
      const count = parseInt(
        html.querySelector("cart-drawer-items")?.getAttribute("item_count") ||
          "0",
        10
      );
      // console.log("count:", count);
      const selectors = [
        ".drawer__inner",
        "cart-drawer-items",
        ".cart-drawer__footer",
      ];
      //document.querySelector(".cart__checkout-button.button").disabled = !1;
      const checkoutButton = document.querySelector(
        "button.cart__checkout-button"
      );
      if (checkoutButton) {
        checkoutButton.disabled = !1;
      }
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        if (count > 0) {
          cartDrawer.classList.remove("is-empty");
          document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
            bubble.classList.remove("hidden");
          });
        } else {
          cartDrawer.classList.add("is-empty");
          document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
            bubble.classList.add("hidden");
          });
        }
      }
      window.dispatchEvent(new Event('cart:refresh'));
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        // console.log({ targetElement, sourceElement, selector }, "<<<sourceElement");
       if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
      }
      initToggleUpsells();
      document
        .querySelectorAll(".cart-count-bubble span:first-child")
        .forEach((bubble) => {
          bubble.textContent = count;
        });
      const totalItemElement = document.querySelector(".ttl_item");
      if (totalItemElement) {
        totalItemElement.textContent = count;
      }

    })
    .catch((error) => {
      console.error("Error refreshing cart:", error);
    });
 
};